/**
 * WARNING! DO not auto format this file!
 * */

const MZ_VERSION = '971db8e';

/*
 * See https://github.com/THE-Engineering/mz/#asynchronous-function-queuing-support
 * for the origin of this snippet
 */
export const loadMzSync = () => {
  /* eslint-disable no-underscore-dangle */
  // @ts-ignore
  (function(w) {w._mz = {};w._mz_def=[];_mz.emit=function(t, d, n) {w._mz_def.push({f:'emit',t:t,d:d,n:n});};}(window));
  /* eslint-enable no-underscore-dangle */
};

/*
 * This lazy loads the MZ bundle. We do this
 * instead of using a standard script tag so we can better
 * control when MZ is loaded
 */
export const loadMzAsync = () =>
  new Promise((resolve, reject) => {
    const script = document.createElement('script');
    document.body.appendChild(script);
    script.onload = resolve;
    script.onerror = reject;
    script.async = true;
    script.src = `https://www.timeshighereducation.com/cdn/mz/${MZ_VERSION}/mz.js`;
  });
